<!-- 废弃 -->
<template>
	<div>
		<myheader headTitle="企业信息"></myheader>
		<div class="header_extend_main">
			<div class="header_extend_back"></div>
			<div class="header_extend_content">
				<div id="Info" class="all_tips_content_card">
					<div style="margin: .5rem auto .2rem;text-align: center;">
						<img style="width: 3rem; height: 3rem; " src="@/assets/images/enterpriseinfo.svg">
						<div class="text14 textcolor333 margin_top_3 font_weight_bold"> {{corpName}}</div>
						<div class="text12 margin_top_5"
							:class="{textcolor666:certStatus==='未下载',textcolormain:certStatus==='已下载'}">
							{{'移动证书（'+certStatus+'）'}}
						</div>
						<div class="text12 textcolor666"
							style="position: absolute;top: 1rem;right: .5rem;padding: .1rem .3rem;"
							:class="{passed:applyStatus==='1',passing:applyStatus==='0'||applyStatus==='3',nopassed:applyStatus==='2'||applyStatus==='4',}">
							{{certifyStatusText}}
						</div>
					</div>
				</div>
			</div>
			<div class="margin_top_10" style="background-color: white;z-index: 10;">
				<div class="all_height_line24 display_flex backgroundC_white bwhite_ative" @click="signetClick()">
					<span class="text14 textcolor333 all_line_height24 display_inline_block"
						style="width: 90%;padding-left: .8rem;">企业印章</span>
					<img src="@/assets/images/u359.png" style="height: .8rem;margin: .8rem;" />
				</div>
				<div class="all_height_line24 display_flex backgroundC_white bwhite_ative" @click="certClick()">
					<span class="text14 textcolor333 all_line_height24 display_inline_block"
						style="width: 90%;padding-left: .8rem;">下载证书</span>
					<img src="@/assets/images/u359.png" style="height: .8rem;margin: .8rem;" />
				</div>
				<div v-if="$store.state.userInfo.staffType <= 2"
					class="all_height_line24 display_flex backgroundC_white bwhite_ative" @click="manageClick()">
					<span class="text14 textcolor333 all_line_height24 display_inline_block"
						style="padding-left: .8rem;" :style="{width:applyCount>0?'83%':'90%'}">成员管理</span>
					<span class="text12 textcolor666 display_inline_block number"
						v-if="applyCount>0">{{applyCount}}</span>
					<img src="@/assets/images/u359.png" style="height: .8rem;margin: .8rem;" />
				</div>
				<!-- <div class="text14 textcolor333 all_height_line22" style="padding: 0 .8rem;" @click="signetClick()">电子印章
					<span class="item"></span>
				</div>
				<div class="text14 textcolor333 all_height_line22" style="padding: 0 .8rem;" @click="certClick()">下载证书
					<span class="item"></span>
				</div> -->
				<!-- 	<div class="text14 textcolor333 all_height_line22" style="padding: 0 .8rem;">变更企业信息
					<span class="item"></span>
				</div> -->
				<!-- <div v-if="$store.state.userInfo.staffType <= 2" class="text14 textcolor333 all_height_line22"
					style="padding: 0 .8rem;" @click="manageClick()">成员管理
					<span class="item"></span>
					<span class="text12 textcolor666 number" v-if="applyCount>0">{{applyCount}}</span>
				</div> -->
			</div>
			<div class="text14 textcolor333 margin_top_10 font_weight_900" style="margin-left: .8rem;">CA申请状态</div>
			<div class="horizontal_line margin_top_5"></div>
			<div class="all_list_content_nopadding" :style="{'top':caTop}">
				<div v-if="CAlist.length===0" style="padding: 1rem .8rem;" class="backgroundC_white">
					<div class="horizontal_line"></div>
					<div class="text12 textcolor333 margin_top_2">还未申请CA认证，请在PC端操作CA认证申请您的移动证书</div>
				</div>
				<div v-if="CAlist.length===0" class="horizontal_line"></div>
				<div v-for="(item,index) in CAlist" :key="index">
					<div style="padding: 0 .8rem;padding-bottom: .5rem;" class="backgroundC_white">
						<div class="all_line_height16">
							<span class="text12 textcolor333 display_inline_block"
								style="width: 50%;">{{item.createdTime}}</span>
							<span class="text12 textcolor999 display_inline_block all_text_right" style="width: 50%;"
								:class="{textcolorNopass:item.applyStatus === 4,textcolorAuth:item.applyStatus === 3}">{{item.applyStatusText}}</span>
						</div>
						<div class="horizontal_line"></div>
						<div class="all_line_height16">
							<span class="text12 textcolor666 display_inline_block"
								style="width: 50%;">{{'申办类型：'+item.applyTypeText}}</span>
							<span class="display_inline_block all_text_right" style="width: 50%;">
								<button v-if="item.canEdit&&item.applyStatus === 4" @click="toEditCA(item)"
									class="text12 textcolorwhite all_line_height14 backgroundC_main bmain_active"
									style="padding: 0 .5rem;border-radius: .2rem;">编辑</button>
							</span>
						</div>
					</div>
					<div class="horizontal_line"></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {
		getLocalCertList
	} from '../../../utils/nativeCertSign.js';
	export default {
		data() {
			return {
				//企业id
				corpId: '',
				//企业名称
				corpName: '',
				//企业信用编码
				creditCode: '',
				//认证状态文本
				certifyStatusText: '',
				//认证状态
				applyStatus: '',
				//用户名
				userName: this.$store.state.loginInfo.userName,
				//证书状态
				certStatus: '未下载',
				//申请加入企业成员数
				applyCount: 0,
				//ca申请列表
				CAlist: [],
				//ca列表top
				caTop: '23.7rem',
			}
		},
		methods: {
			//重新认证ca
			toEditCA(item) {
				this.$router.push({
					path: 'editenterprisecaapplyinfo',
					query: {
						applyId: item.applyId,
					}
				})
			},
			//证书列表
			certClick() {
				this.$router.push({
					path: 'certlist',
					query: {
						corpId: this.corpId,
						creditCode: this.creditCode
					}
				})
			},
			//印章列表
			signetClick() {
				this.$router.push({
					path: '/signetlist',
					query: {
						corpId: this.corpId,
					}
				})
			},
			//跳转到成员管理
			manageClick() {
				if (this.$store.state.userInfo.staffType <= 2) {
					this.$router.push({
						path: '/enterprisemembermanage',
						query: {
							corpId: this.corpId,
							corpName: this.corpName
						}
					})
				}
			},
			//获取申请人数
			getApplyCount() {
				this.$get('/corp/api/getApplyCount/'+this.corpId, {}).then((res) => {
					if (res.success && res.data) {
						this.applyCount = res.data
					}
				})
			},
			//设置ca列表top
			setCaTop() {
				let fontsize = document.firstElementChild.style.fontSize.replace('px', '')
				//console.log(document.getElementById('Info').clientHeight)
				if (this.$store.state.userInfo.staffType <= 2) {
					this.caTop = (document.getElementById('Info').clientHeight + Number(fontsize) * 15.25) + 'px'
				} else {
					this.caTop = (document.getElementById('Info').clientHeight + Number(fontsize) * 12.85) + 'px'
				}
				//console.log(this.caTop)
			},
			//获取ca申请列表
			getCaApplyList() {
				this.$store.dispatch(this.$LoadShow, true)
				this.$post('/cert/api/certs/'+this.corpId, {}).then((res) => {
					this.$store.dispatch(this.$LoadShow, false)
					if (res.success && res.data) {
						this.setCaTop()
						this.CAlist = res.data
						// this.CAlist.forEach((item) => {
						// 	console.log(typeof item.canEdit)
						// })
					}
				})
			},
			//企业证书是否下载 -获取本地证书列表并匹配企业编号
			getLoaclCertList() {
				//getLocalCertList(String userName)
				getLocalCertList(this.userName).then(res=>{
					var list = JSON.parse(res)
					list.forEach((item) => {
						if (item.subject.indexOf(this.creditCode) != -1) {
							this.certStatus = '已下载'
						}
					})
				})
				//console.log(list)
			},
			//初始化
			init() {
				this.corpId = this.$route.query.corpId
				this.corpName = this.$route.query.corpName
				this.creditCode = this.$route.query.creditCode
				this.certifyStatusText = this.$route.query.certifyStatusText
				this.applyStatus = this.$route.query.applyStatus
				//console.log(typeof this.applyStatus)
				if (this.$store.state.userInfo.staffType <= 2) {
					this.getApplyCount()
				}
				this.getCaApplyList()
				this.getLoaclCertList()
			},
		},
		mounted() {
			this.init()
		},
	}
</script>

<style scoped lang="scss">
	@import "../../../styles/global.css";

	.number {
		width: 1.2rem;
		height: 1.2rem;
		line-height: 1.2rem;
		margin: .6rem 0;
		background-color: #aaa;
		border-radius: 1rem;
		text-align: center;
	}

	.item {
		float: right;
	}

	.item::after {
		content: url('../../../assets/images/u359.png');
		display: inline-block;
		width: .7rem;
		//padding-top: .2rem;
		//margin-top: .3rem;
		// height: 1.4rem;
		// line-height: 1.4rem;
		// margin: 0 .5rem;
	}


	.passed {
		color: #66BE74;
		border: 1px solid #66BE74;
	}

	.passing {
		color: #FAAD15;
		border: 1px solid #FAAD15;
	}

	.nopassed {
		color: #DF4545;
		border: 1px solid #DF4545;
	}
</style>